import { contract } from '@here/api'
import { user } from '@state'
import { initClient } from '@ts-rest/core'

export const apiClient = initClient(contract, {
	baseUrl: 'http://localhost:8001/api',
	baseHeaders: {
		Authorization: () => {
			const token = user()?.access_token
			return token ? `Bearer ${token}` : ''
		},
	},
})
